// extracted by mini-css-extract-plugin
export default {"component":"DisplayResults_component__QKsmf"};